import useFieldTypes from "../../../../api/api-hooks/cloud/useFieldTypes";
import FieldTypeCalculated from "./FieldTypeCalculated";
import FieldTypeReference from "./FieldTypeReference";
import FieldUtils from "../../../../utils/FieldUtils";
import Constants from "../../../../utils/Constants";
import FieldTypeSubitem from "./FieldTypeSubitem";
import FieldTypeToggle from "./FieldTypeToggle";
import FieldTypeSelect from "./FieldTypeSelect";
import FieldTypeFilter from "./FieldTypeFilter";
import FieldTypeImage from "./FieldTypeImage";
import FieldTypeFiles from "./FieldTypeFiles";
import FieldTypeUrl from "./FieldTypeUrl";

interface Props {
  fieldValues: any;
  setFieldValues: any;
  showModificationProtection: any;
  setDisabled: any;
  moduleAPIName: any;
  allowFieldTypeEdit: boolean;
}

const FieldTypeSpecific = ({
  fieldValues,
  setFieldValues,
  showModificationProtection,
  setDisabled,
  moduleAPIName,
  allowFieldTypeEdit,
}: Props) => {
  const { fieldTypes } = useFieldTypes();

  return (
    <>
      {/* --------------------- References / Selects Management ----------------- */}
      {FieldUtils.fieldTypeHasOptions(fieldTypes, fieldValues.fieldType) && (
        <>
          {FieldUtils.fieldTypeIsSelect(fieldValues.fieldType) ? (
            <FieldTypeSelect
              fieldValues={fieldValues}
              setFieldValues={setFieldValues}
              showModificationProtection={showModificationProtection}
            />
          ) : FieldUtils.fieldTypeIsCalculated(fieldValues.fieldType) ? (
            <FieldTypeCalculated
              fieldValues={fieldValues}
              setFieldValues={setFieldValues}
              setDisabled={setDisabled}
            />
          ) : fieldValues.fieldType === Constants.FIELDTYPES.FILTER ? (
            <FieldTypeFilter
              fieldValues={fieldValues}
              setFieldValues={setFieldValues}
            />
          ) : (
            <FieldTypeReference
              fieldValues={fieldValues}
              setFieldValues={setFieldValues}
              showModificationProtection={showModificationProtection}
              moduleAPIName={moduleAPIName}
            />
          )}
        </>
      )}
      {/* ------------------------- Toggle Related ------------------------------ */}
      {fieldValues.fieldType === Constants.FIELDTYPES.TOGGLE && (
        <FieldTypeToggle
          fieldValues={fieldValues}
          setFieldValues={setFieldValues}
          showModificationProtection={showModificationProtection}
        />
      )}
      {/* -------------------------------- Subitem Related ------------------------------- */}
      {FieldUtils.fieldTypeIsSubitem(fieldValues.fieldType) && (
        <FieldTypeSubitem
          fieldValues={fieldValues}
          setFieldValues={setFieldValues}
          allowFieldTypeEdit={allowFieldTypeEdit}
        />
      )}
      {/* -------------------------------- Image Related -------------------------------- */}
      {fieldValues.fieldType === Constants.FIELDTYPES.IMAGE && (
        <FieldTypeImage
          fieldValues={fieldValues}
          setFieldValues={setFieldValues}
        />
      )}
      {/* -------------------------------- Attachment Related -------------------------------- */}
      {(fieldValues.fieldType === Constants.FIELDTYPES.AUDIO ||
        fieldValues.fieldType === Constants.FIELDTYPES.VIDEO ||
        fieldValues.fieldType === Constants.FIELDTYPES.SINGLE_FILE) && (
        <FieldTypeFiles
          fieldValues={fieldValues}
          setFieldValues={setFieldValues}
        />
      )}
      {/* -------------------------------- URL Related -------------------------------- */}
      {fieldValues.fieldType === Constants.FIELDTYPES.URL && (
        <FieldTypeUrl
          fieldValues={fieldValues}
          setFieldValues={setFieldValues}
        />
      )}
    </>
  );
};

export default FieldTypeSpecific;
